"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./ThemeProvider.css");
var _cdsCommon = require("@cbhq/cds-common");
var _FramerMotionProvider = require("../animation/FramerMotionProvider");
var _linaria = require("../utils/linaria");
var _useThemeProviderStyles = require("./useThemeProviderStyles");
const _excluded = ["children", "display", "motionFeatures"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// https://developer.mozilla.org/en-US/docs/Web/CSS/display#display_contents
const displayContents = "cds-displayContents-de086gm";
const ThemeManager = ({
  children,
  display
}) => {
  const _useThemeProviderStyl = (0, _useThemeProviderStyles.useThemeProviderStyles)(),
    style = _useThemeProviderStyl.style,
    className = _useThemeProviderStyl.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _linaria.cx)(className, display === 'contents' && displayContents),
    style: style
  }, children);
};
const ThemeProvider = /*#__PURE__*/(0, _react.memo)(_ref => {
  let children = _ref.children,
    display = _ref.display,
    motionFeatures = _ref.motionFeatures,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_FramerMotionProvider.FramerMotionProvider, {
    motionFeatures: motionFeatures
  }, /*#__PURE__*/_react.default.createElement(_cdsCommon.SystemProvider, props, /*#__PURE__*/_react.default.createElement(ThemeManager, {
    display: display
  }, children)));
});
exports.ThemeProvider = ThemeProvider;
ThemeProvider.displayName = 'ThemeProvider';